import React, { PureComponent } from 'react';
import { Toast } from 'react-bootstrap';

class Toaster extends PureComponent {

  handleOnClose = () => {
    const { data } = this.props;

    this.props.onClose(data);
  }

  render() {
    const { title, message, time, autohide = true, delay = 15000, variant = 'default' } = this.props.data;

    return (
      <Toast autohide={ autohide }
        delay={ delay }
        className={ `toast-${variant}` }
        onClose={ this.handleOnClose }
      >
        <Toast.Header>
          <strong className="mr-auto">
            { title || 'Notificación' }
          </strong>

          { time && <small>{ time }</small> }
        </Toast.Header>
        <Toast.Body>
          { message }
        </Toast.Body>
      </Toast>
    )
  }
}

export default Toaster;